import { all } from 'redux-saga/effects';
import { appSagas } from 'app/app.sagas';
import { conversationsBulkModalSagas } from 'app/components/appModals/components/conversationsBulkModal/conversationsBulkModal.sagas';
import { profileSagas } from 'app/views/layout/views/settings/views/profile/settingsProfile.sagas';
import { bulkActions as bulkActionsSagas } from 'components/bulkActions/sagas/bulkActions';
import { conversation as conversationSagas } from 'components/conversation/sagas/conversation';
import { conversationForm as conversationFormSagas } from 'components/conversation/sagas/conversationForm';
import { conversations as conversationsSagas } from 'components/conversation/sagas/conversations';
import { elevio as elevioSagas } from 'components/conversation/sagas/elevio';
import { feedback as feedbackSagas } from 'components/conversation/sagas/feedback';
import { originalEmail as originalEmailSagas } from 'components/conversation/sagas/originalEmail';
import { satisfaction as satisfactionSagas } from 'components/conversation/sagas/satisfaction';
import { timeline as timelineSagas } from 'components/conversation/sagas/timeline';
import { conversationsOverview as conversationsOverviewSagas } from 'components/conversationsOverview/sagas/conversationsOverview';
import { dashboard as dashboardSagas } from 'components/dashboard/sagas/dashboard';
import { notifications as notificationsSagas } from 'components/notifications/sagas/notification';
import { holdMusic as holdMusicSagas, waitMusic as waitMusicSagas, } from 'components/powerCallFlow/components/modals/utils/shared/sagas/waitHoldMusic';
import { callFlow as callFlowSagas } from 'components/powerCallFlow/sagas/callFlow';
import { callFlows as callFlowsSagas } from 'components/powerCallFlow/sagas/callFlows';
import { flowLanguages as flowLanguagesSagas } from 'components/powerCallFlow/sagas/flowLanguages';
import { chatFlow as chatFlowSagas } from 'components/powerChatFlow/sagas/chatFlow';
import { chatFlows as chatFlowsSagas } from 'components/powerChatFlow/sagas/chatFlows';
import { emailFlow as emailFlowSagas } from 'components/powerEmailFlow/sagas/emailFlow';
import { presence as presenceSagas } from 'components/presence/sagas/presence';
import { organization as organizationV2Sagas } from 'components/settings/organization/sagas/organization';
import { chatWidgets as chatWidgetsSagas } from 'components/settings/sagas/chatWidgets';
import { customCards as customCardsSagas } from 'components/settings/sagas/customCards';
import { email as emailSagas } from 'components/settings/sagas/email';
import { jabra as jabraSagas } from 'components/settings/sagas/jabra';
import { magentoCards as magentoCardsSagas } from 'components/settings/sagas/magentoCards';
import { messaging as messagingSagas } from 'components/settings/sagas/messaging';
import { organization as organizationSagas } from 'components/settings/sagas/organization';
import { personal as personalSagas } from 'components/settings/sagas/personal';
import { queues as queuesSagas } from 'components/settings/sagas/queues';
import { salesforceCards as salesforceCardsSagas } from 'components/settings/sagas/salesforceCards';
import { satisfaction as satisfactionSettingsSagas } from 'components/settings/sagas/satisfaction';
import { shopifyCards as shopifyCardsSagas } from 'components/settings/sagas/shopifyCards';
import { telephony as telephonySagas } from 'components/settings/sagas/telephony';
import { templates as templatesSagas } from 'components/settings/sagas/templates';
import { whatsapp as whatsappSagas } from 'components/settings/sagas/whatsapp';
import { addCaller as addCallerSagas } from 'components/shared/addCallerModal/sagas/addCaller';
import { audioSagas as audioSagasSagas } from 'components/shared/audio/sagas/audio';
import { companyModalSagas as companyModalSagasSagas } from 'components/shared/companyModal/sagas/companyModal';
import { composeEmail as composeEmailSagas } from 'components/shared/composeEmail/sagas/composeEmail';
import { transferToAgentModal as transferToAgentModalSagas } from 'components/shared/transferToAgentModal/sagas/transferToAgent';
import { transferToNumberModal as transferToNumberModalSagas } from 'components/shared/transferToNumberModal/sagas/transferToNumber';
import { transferToQueueModal as transferToQueueModalSagas } from 'components/shared/transferToQueueModal/sagas/transferToQueueModal';
import { richTextField as richTextFieldSagas } from 'components/shared/util/richTextField/sagas/richTextField';
import { telephonySagas as telephonySagasSagas } from 'components/telephony/sagas/telephony';
import { userModalSagas } from 'components/usersModal';
import { electronSagas } from 'middleware/electron';
import { keyboardShortcuts as keyboardShortcutsSagas } from 'middleware/keyboardShortcuts/sagas/keyboardShortcuts';
import { twilio as twilioSagas } from 'middleware/twilio/sagas/twilio';
import { websocket as websocketSagas } from 'middleware/websocket/sagas/websocket';
/** The application sagas. */
export function* sagas() {
    yield all([
        ...conversationsBulkModalSagas,
        ...addCallerSagas,
        ...appSagas,
        ...audioSagasSagas,
        ...bulkActionsSagas,
        ...callFlowSagas,
        ...callFlowsSagas,
        ...chatFlowSagas,
        ...chatFlowsSagas,
        ...chatWidgetsSagas,
        ...companyModalSagasSagas,
        ...composeEmailSagas,
        ...conversationFormSagas,
        ...conversationSagas,
        ...conversationsOverviewSagas,
        ...conversationsSagas,
        ...customCardsSagas,
        ...dashboardSagas,
        ...electronSagas,
        ...elevioSagas,
        ...emailFlowSagas,
        ...emailSagas,
        ...feedbackSagas,
        ...flowLanguagesSagas,
        ...holdMusicSagas,
        ...jabraSagas,
        ...keyboardShortcutsSagas,
        ...magentoCardsSagas,
        ...messagingSagas,
        ...notificationsSagas,
        ...organizationSagas,
        ...organizationV2Sagas,
        ...originalEmailSagas,
        ...personalSagas,
        ...presenceSagas,
        ...profileSagas,
        ...queuesSagas,
        ...richTextFieldSagas,
        ...salesforceCardsSagas,
        ...satisfactionSagas,
        ...satisfactionSettingsSagas,
        ...shopifyCardsSagas,
        ...telephonySagas,
        ...telephonySagasSagas,
        ...templatesSagas,
        ...timelineSagas,
        ...transferToAgentModalSagas,
        ...transferToNumberModalSagas,
        ...transferToQueueModalSagas,
        ...twilioSagas,
        ...userModalSagas,
        ...waitMusicSagas,
        ...websocketSagas,
        ...whatsappSagas,
    ]);
}
